import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Row } from '../components/index.js';
import { renderDndColumns } from './renderDndColumns.js';
import { useDndRow } from './useDndRow.js';
export const DndRow = memo(function DndRow({ id, index, group, columns, itemProps, ...rowProps }) {
    const { ref, dragHandleRef, targetRef, isDragging } = useDndRow({ id, index, group });
    return (_jsx(Row, { ref: ref, targetRef: targetRef, isDragging: isDragging, ...rowProps, children: renderDndColumns(columns, { ...itemProps, dragHandleRef }) }));
});
